const APP_PREFIX = 'ai-go-studio'

export const prefix = (key: string): string => `${APP_PREFIX}:${key}`

export const persist = <T>(key: string, value: T): T => {
  localStorage.setItem(prefix(key), JSON.stringify(value))
  return value
}

export const retrieve = <T>(key: string): T | undefined => {
  const value = JSON.parse(localStorage.getItem(prefix(key)) || 'null')
  return value !== null ? (value as T) : undefined
}
